import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  overflow: hidden;
  padding: 1rem 1.5rem;
  width: calc(100% - 3rem);
  justify-content: space-between;
  transition: all 0.3s ease-in-out;
  opacity: 1;
  cursor: pointer;

  @media (max-width: 1000px) {
    padding: 1rem 8px;
    width: calc(100% - 16px);
    flex-direction: column;
  }

  &:hover,
  &:focus {
    opacity: 0.8;
  }

  button {
    pointer-events: none;
  }
`;
